export default "__VITE_ASSET__vfS2gV$v__"